module.exports = __webpack_public_path__ + "img/phon8.4a3e5f5c.png";